<template>
  <v-container>
    <div class="display-2 mb-7 mt-5 font-weight-thin" color="primary">{{$tc('entities.stageType.title',2)}}</div>

    <alert-box v-model="alert.alerts" :type="alert.type"></alert-box>
    <btn-a rounded color="primary" @click="editItem" :access="$access.stageType.edit">
      <v-icon>mdi-plus</v-icon>
    </btn-a>
    <table-grid
      :headers="headers"
      :items="items"
      :loading="loadingTable"
      :loadingAction="loadingDialog"
      :actions="actions"
      :page="pagination.page"
      :pageLength="lengthPaginationComp"
       @input="pagination.page = $event"
           @search="searchTable"
    />

    <dialog-d
      ref="dialogEdit"
      :title="$tc('entities.stageType.title')"
      :deleteButton="itemSelected && itemSelected.id"
      @confirm="saveItem(itemSelected,$refs.form.isValid())"
      @delete="deleteItem(itemSelected,true)"
      :loading="loadingDialog"
      :accessConfirm="$access.stageType.edit"
      :accessDelete="$access.stageType.delete"
      :alert="form.alert"
    >
      <stageTypeForm ref="form" v-if="itemSelected" v-model="itemSelected" @changeRegTypeIds="itemSelected.regTypeIds = $event" />
    </dialog-d>
  </v-container>
</template>

<script>
import stageTypeService from '@/services/stageTypeService.js'
import stageTypeForm from "../components/forms/stageTypes/stageTypeForm";
import pageListMixing from "../mixins/pageLists/pageListMixing.js";
export default {
  mixins: [pageListMixing],
  components: { stageTypeForm },

  data() {
    return {
      apiController: "stageType",
      searchFields:["description"],
      entityService:stageTypeService,
      headers: [
        {
          text: this.$t("entities.stageType.props.description"),
          align: "left",
          sortable: false,
          value: "description"
        },

        { text: this.$t("table.actions"), value: "action", sortable: false, align: "right" }
      ],
      actions: [
        {
         text: this.$t("edit"),
          icon: "mdi-pencil",
          handle: this.editItem,
          access: [this.$access.stageType.edit, this.$access.stageType.show]
        },
        {
          text: this.$t("delete"),
          icon: "mdi-delete",
          handle: this.deleteItem,
          access: this.$access.stageType.delete
        }
      ]
    };
  },
  methods: {
    async getModelDefault() {
      return {
        description: "",
        regTypeIds: []
      };
    }
  },
  async mounted() {
    await this.getItems();
  }
};
</script>